import React from "react";

export default function Som() {
    return (
        <svg height=".8em" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_621_236)">
                <path d="M4.68751 0C4.07194 -6.83506e-08 3.46239 0.127148 2.89368 0.374183C2.32496 0.621218 1.80821 0.983303 1.37294 1.43976C0.937664 1.89623 0.592384 2.43813 0.356815 3.03452C0.121245 3.63092 -6.51782e-08 4.27013 0 4.91566C-6.51782e-08 5.5612 0.121245 6.20041 0.356815 6.7968C0.592384 7.3932 0.937664 7.9351 1.37294 8.39156C1.80821 8.84802 2.32496 9.21011 2.89368 9.45714C3.46239 9.70418 4.07194 9.83132 4.68751 9.83132C5.93029 9.83017 7.12177 9.31151 8 8.38938L7.02577 7.36773C6.40583 8.01864 5.56477 8.38474 4.68751 8.38554C3.80995 8.38554 2.96834 8.01997 2.34781 7.36924C1.72729 6.71851 1.37868 5.83593 1.37868 4.91566C1.37868 3.99539 1.72729 3.11282 2.34781 2.46209C2.96834 1.81136 3.80995 1.44578 4.68751 1.44578C5.56477 1.44658 6.40583 1.81268 7.02577 2.46359L8 1.44194C7.12177 0.519812 5.93029 0.00115514 4.68751 0ZM0 10.5542V12H8V10.5542H0Z" fill="#1BAB77" />
            </g>
            <defs>
                <clipPath id="clip0_621_236">
                    <rect width="8" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}